import React, { Component } from "react";
import clsx from 'clsx';
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../../assets/img/svg/save.svg';
import Cancel from '../../../../assets/img/svg/cancel.svg';
import Delete from '../../../../assets/img/svg/delete.svg'
import download from "../../../../assets/img/svg/DownloadIcon.svg"
import { Tabs, Tab, AppBar, Typography, Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import EditPBD_Detail from './EditPBD-Detail'
import EditPBD_Historylog from './Historylog'
import del from "../../../../assets/img/svg/Del.svg"
import { useNavigate } from "react-router-dom"
import $ from 'jquery';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
//mport PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import { putpbddocinfo, deletemulitipbddocs } from "../../../../actions/PBDAction";
import axios from "axios";
import API from "../../../../_helpers/endpointService";
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        boxShadow: "none !important"
    },
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
    },
    indicator: {
        backgroundColor: "#00838F",
    },
}));

class EditPBD extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ProjectId: 0,
            Docs: [],
            DeleteData: [],
          
            isMobile: false,
            Error: {
                "DescriptionError": false,
                
                "DateError": false,
            },
            value: 0,
            addData: {
                "Id": 0,
                "ProjectId": 0,
                "Description": "",  
                "Date": "",
                "Comments": ""
            }
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.addData.Id = parseInt(localStorage.getItem("PBDEditId"))
        let tempdata = {
            data: parseInt(localStorage.getItem("PBDEditId"))
        }
        this.state.DeleteData.push(tempdata)
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.setState({})
        this.props.dispatch({ type: "ERROR_PBDFILES", data: this.state.Error })
        window.location.pathname == '/prebeachingdocuments/edit' ? this.setState({ isView: false }) : this.setState({ isView: false })
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#Prebeaching1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Prebeaching").addClass("d-none");
        $("#Prebeaching").removeClass("d-block");
        $("#PBDL").removeClass("active-color");
        $("#PBDT").removeClass("fw-bolder");
    }

    handleChange = (event, newValue) => {
        this.setState({
            value: newValue,
        })
    };

    sidebar = () => {
        this.props.navigate("/sidebar");
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#Prebeaching1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Prebeaching").removeClass("d-none");
        $("#Prebeaching").addClass("d-block");
        $("#PBDL").addClass("active-color");
        $("#PBDT").addClass("fw-bolder");
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.addData = this.props.sharedpbdfile;
        this.setState({})
    };
    EditCancel = () => {
        let tempData = {
            "Id": 0,
            "ProjectId": 0,
            "Description": "",
           
            "Date": "",
            "Comments": ""
        }
        this.props.dispatch({ type: "SHARE_PBDFILES", data: tempData })
        this.props.dispatch({ type: "SHARE_PBDDATAS", data: [] })
        this.props.navigate("/prebeachingdocuments")
    };

    EditSave = () => {
        if (this.props.sharedpbdfile.Description == "") {
            this.state.Error.DescriptionError = true;
            this.setState({})
            this.props.dispatch({ type: "ERROR_PBDFILES", data: this.state.Error })
        }
        else {
            this.state.Error.DescriptionError = false;
            this.setState({})
        }
       
        if (this.props.sharedpbdfile.Date == "") {
            this.state.Error.DateError = true;
            this.setState({})
            this.props.dispatch({ type: "ERROR_PBDFILES", data: this.state.Error })
        }
        else {
            this.state.Error.DateError = false;
            this.setState({})
        }
        if (this.props.sharedpbdfile.Description  !== '' && this.props.sharedpbdfile.Date !== '' ) {
            let formData = new FormData()
            let array = [];
            Array.from(this.props.sharedpbddata).forEach(async (a) => {
                if (a.AwsUniqueFileName == undefined) {
                    formData.append("attachments", a.fdata)
                    array.push(a)
                }
            })
            this.putpbddocinfo(this.props.sharedpbdfile, formData, this.state.addData.Id, array)
        }
        else {
            this.props.dispatch({ type: "ERROR_PBDFILES", data: this.state.Error })
        }
    }
    putpbddocinfo = (data, formData, id, array) => {
        let apiUrl = API.PBD_LISTVIEW + '/' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
          axios({
            method: "PUT",
            url: apiUrl,
            data: data,
           
          })
            .then((response) => {
              if (response?.status === 200) {
                if (array.length > 0) {
                this.adduploadpbddocinfo(formData, id)
                }
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                this.props.navigate("/prebeachingdocuments")

              } else {
              }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
              if (error?.response?.status === 401) {
              
              }
            });
        };
      
      
       adduploadpbddocinfo = (data, id) => {
        let apiUrl = API.PBD_LISTVIEW + '/' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })

        
          axios({
            method: "POST",
            url: apiUrl,
            data: data,
           
          })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

              if (response?.status === 200) {
                this.props.navigate("/prebeachingdocuments")

              } else {
              }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

              if (error?.response?.status === 401) {
                // logOut();
              }
            });
        };
      
    DeleteItem = () => {
        this.props.dispatch(deletemulitipbddocs(this.state.DeleteData, this.state.ProjectId))
        let tempData = {
            "Id": 0,
            "ProjectId": 0,
            "Description": "",
          
            "Date": ""
        }
        this.props.dispatch({ type: "SHARE_PBDFILES", data: tempData })
        this.props.dispatch({ type: "SHARE_PBDDATAS", data: [] })
    }

    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"Prebeaching" + "1"} className='  textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="Prebeaching" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5 ">
                                    <h4>Pre-Beaching / Landing Documents</h4>
                                </div>
                            </div>


                        </>

                        :
                        <></>
                }
                <div className={`${this.state.isMobile ? "ml-auto scroll-hide" : "ml-auto"}`} style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ?
                        <table className="dataTable border-top" width="100%">
                            <tbody>
                                <tr>
                                    <td className="border-right text-center">
                                        <i class="fa fa-arrow-left cursorPointer" onClick={this.EditCancel}></i></td>
                                    <td className="border-right text-center">
                                        {this.state.isView ? <></> :
                                            <button className={classes.button} onClick={() => this.EditSave()}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>}
                                    </td>
                                    <td className="border-right text-center">
                                        <button className={`${classes.button} pl-3`} onClick={this.EditCancel}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                    </td>
                                    <td className="border-right text-center">
                                        {this.state.isView ? <></> :
                                            <button className={`${classes.button} pl-3`} data-target="#deletespopup" data-toggle="modal" ><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete</button>}
                                    </td>
                                </tr>
                            </tbody>
                        </table> :
                        <table className="dataTable" width="100%">
                            <tbody>
                                <tr>
                                    <td width="5%" className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.EditCancel}></i></td>
                                    <td width="95%">
                                        {this.state.isView ? <></> :
                                            <button className={classes.button} onClick={() => this.EditSave()}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>}
                                        <button className={`${classes.button} pl-3`} onClick={this.EditCancel}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                        {this.state.isView ? <></> :
                                            <button className={`${classes.button} pl-3`} data-target="#deletespopup" data-toggle="modal" ><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete</button>}
                                        {this.state.isView ? <button className={`${classes.button} pl-3`}><img src={download} style={{ marginTop: '-4px' }}></img>&nbsp;Download</button> : <></>}
                                    </td>
                                </tr>
                            </tbody>
                        </table>}
                    <div style={{ margin: this.state.isMobile ? "0" : "15px 45px" }}>
                        {this.state.isMobile ? <></> : <h6 className="col-12 ml-2">Pre-Beaching / Landing Documents</h6>}
                        <div className="row mt-4">
                            <div >
                                <AppBar position="static" color="inherit" className={classes.root}>
                                    <Tabs
                                        value={this.state.value}
                                        onChange={this.handleChange}
                                        classes={{ indicator: classes.indicator }}
                                    >
                                        <Tab label="Details" {...a11yProps(0)} />
                                        <Tab label="History log" {...a11yProps(1)} />
                                    </Tabs>
                                </AppBar>
                                <TabPanel value={this.state.value} index={0}>
                                    <EditPBD_Detail />
                                </TabPanel>
                                <TabPanel value={this.state.value} index={1}>
                                    <EditPBD_Historylog />
                                </TabPanel>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletespopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        sharedpbdfile: state.PBDReducer.sharedpbdfile || [],
        sharedpbddata: state.PBDReducer.sharedpbddata || [],
        PBDDESC_LOOKUP: state.PBDReducer.PBDDESC_LOOKUP || [],
        otherspbdpass: state.PBDReducer.otherspbdpass
    };
}

EditPBD.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditPBD))
);


